<template>
    <DCard
        padding
    >
        <EmailSampleTable
            v-for="(items, index) in emails"
            :key="index"
            :category="index"
            :items="items"
            @open-email-sample="openEmailSampleModal"
        />
        <EmailSampleTable
            v-if="templatesWithoutSamples.length > 0"
            category="without_sample"
            :items="templatesWithoutSamples"
        />

        <EmailPreviewModal
            :show-modal="showModal"
            :email-type="chosenEmail"
            :sample="chosenSample"
            :brands="brands"
            :available-languages="availableLanguages"
            @closeModal="closeModal"
        />
    </DCard>
</template>

<script>
import EmailPreviewModal from '~@/Components/Tools/Emails/EmailPreviewModal'
import EmailSampleTable from '~@/Components/Tools/Emails/EmailSampleTable.vue'

export default {
    name: 'EmailIndex',
    components: {
        EmailSampleTable,
        EmailPreviewModal
    },
    props: {
        brands: {
            type: Array,
            default: () => { return [] }
        },
        emails: {
            type: Object,
            default: () => { return {} }
        },
        templatesWithoutProvider: {
            type: Array,
            default: () => { return [] }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            showModal: false,
            chosenEmail: '',
            chosenSample: '',
            brand: this.brands[0]?.id
        }
    },
    computed: {
        brandOptions () {
            return this.brands.map(brand => {
                return {
                    value: brand.id,
                    label: brand.name
                }
            })
        },
        templatesWithoutSamples () {
            return this.templatesWithoutProvider.map((type) => ({ type, samples: { samples: [], type: name } }))
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        openEmailSampleModal ({ document, sample }) {
            this.chosenEmail = document
            this.chosenSample = sample
            this.showModal = true
        },
        closeModal () {
            this.showModal = false
        },
        editSample (item) {
            this.$inertia.get(this.$route('tools.emails.editor.index', { emailType: item.type }))
        }
    }
}
</script>
